import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Account } from 'graphql/models/generated';
import { Observable, throwError } from 'rxjs';
import { AccountService } from 'shared/services/account.service';
import { CoreDataService } from 'shared/services/core-data.service';
import { StoreService } from 'shared/services/store.service';


@Component({
  selector: 'app-delete-account-modal',
  templateUrl: './delete-account-modal.component.html',
  styleUrls: ['./delete-account-modal.component.scss']
})
export class DeleteAccountModalComponent implements OnInit {

  form!: UntypedFormGroup;

  dropdownData: any = {
    accounts: []
  }

  selectedItem?: Account;

  constructor(
    protected fb: UntypedFormBuilder,
    private coreDataService: CoreDataService,
    private accountService: AccountService,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.storeService.setFormReady(false);

    this.form = this.fb.group({
      account: ['', Validators.required]
    });

    this.coreDataService.getAccounts({take: 2000}).subscribe((accounts)=> {
      this.dropdownData.accounts = accounts.sort((a, b) => {
        return a.username.localeCompare(b.username);
      });
      this.storeService.setFormReady(true);
    });

    this.form.statusChanges.subscribe(status => {
      console.log('Status changed:', status);
    });
  }

  onAccountChange(selectedAccount: Account): void {
    this.selectedItem = selectedAccount;
    this.form.updateValueAndValidity({ emitEvent: true });
  }

  onSubmit(): Observable<any> {
    if (!this.selectedItem || !this.selectedItem.id) {
      return throwError(() => new Error('Cannot delete account: ID is undefined'));
    }
    
    return this.accountService.deleteAccount(this.selectedItem.id);
  }
}
